import React, { StrictMode } from "react";
import ReactDOM, { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App.tsx";
import { AppThemeProvider } from "./contexts/ThemeProvider";
import { ToastProvider } from "./contexts/ToastContext";
import store from "./store";
import "./styles/index.css";

// Initialize react-axe for development environment
if (import.meta.env.DEV) {
  import("@axe-core/react").then((axe) => {
    axe.default(React, ReactDOM, 1000);
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <AppThemeProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AppThemeProvider>
    </Provider>
  </StrictMode>,
);
